<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Kontrole predelovalca</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
      <div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezonePisanje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            /> 
          <predelovalec :predelovalec="predelovalec">
          </predelovalec>
            
          </div>
        </div>
      
    <div class="uporabnik-spacer" style="margin-top:2rem"></div>
    <Grid  
                       
                      
                        :data-items="gridData"
                        :columns="columns"
                    
                       
                       :edit-field="'inEdit'"
                        @itemchange="itemChange"

                        
                         :row-render="rowRenderFunction"
                      
                        

                         
                        
                                               >
                 <template v-slot:ukaznigumbi="{props}">
                  <ukaznigumbiknt :data-item="props.dataItem"   :editDisabled="editDisabled"
                    @edit="edit"
                    @save="saveItem" 
                    @remove="removeItem"
                    @cancel="cancel"/>

                    </template>
                <template v-slot:vrstakontrole="{props}">
                      <ddcell :data-item="props.dataItem" 
                        :field="props.field"

                        :sifrantData="sifrant['vrstakontrolepredelovalca']"
                        :selectedValue="{id:props.dataItem.vrstakontroleid,naziv:props.dataItem.vrstakontrole}"
                        @change="(e) => sifranKontrolaChange(e, props.dataItem)"
                   />
                    </template>



 <template v-slot:mnenjekontrolorja="{props}">
                      <ddcell :data-item="props.dataItem" 
                        :field="props.field"

                        :sifrantData="sifrant['mnenjekontrolorja']"
                        :selectedValue="{id:props.dataItem.mnenjekontrolorjaid,naziv:props.dataItem.mnenjekontrolorja}"
                        @change="(e) => sifranMnenjeChange(e, props.dataItem)"
                   />
                    </template>

                   
                   
                 
                        <toolbar>
                             
                        <div class="km-widget km-buttongroup k-widget k-button-group">
                       
                        <button title="Dodaj" :disabled="editDisabled"
                                class="k-button k-primary"
                                @click="vstavi">
                                Dodaj kontrolo
                        </button>
                      
                        
                        <!--
                             <button :disabled="editDisabled"
                                title="Prenesi iz prejšnje sezone"
                                class="k-button k-primary"
                               @click="dodajIzPrejsnjeSezone"
                            >
                                Prenesi iz prejšnje sezone
                            </button>
                          -->
                             <button :disabled="editDisabled"
                                title="Shrani kontrole"
                                class="k-button k-primary"
                                @click="shraniKontrole"
                            >
                                Shrani
                            </button>

                                  <button class="k-button k-primary"  title="Nazaj" @click="nazaj" >Nazaj</button>
                       </div>
                            
                        </toolbar>
                         <GridNoRecords >
                    <div v-if="dataLoading" class="k-loading-mask loadingIconSpace">
                      <span class='k-loading-text'></span>
                      <div class='k-loading-image'></div>
                      <div class='k-loading-color'></div>
                      
                    </div>
                    <div v-else>
                      Ni podatkov!
                    </div>
                    </GridNoRecords>
                    </Grid>

                    </div>
    </div>

</template>

<script>
import { mapState, mapActions,mapMutations } from 'vuex'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
//import '@progress/kendo-ui' // This will import the entire Kendo UI library
import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
import { Grid, GridToolbar, GridNoRecords  } from '@progress/kendo-vue-grid';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import StatusDownCell from './support/SifrantStatusovDropDown';
import StatusCommandCell from './support/SifrantStatusovCommandCell';
//import SifrantKontrolaDownCell from './support/SifrantKontrolaDropDown';
import PredelovalecKratko from './support/PredelovalecKratko';
import { process } from '@progress/kendo-data-query';
import moment from 'moment'






export default {
  components:{
      'ukaznigumbiknt': StatusCommandCell,
      'ddcell': StatusDownCell,
  //    'sifkontroleddcell': SifrantKontroleDownCell,
      'Grid': Grid,
      'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
      'predelovalec':PredelovalecKratko
  },
  props:['sezona','predelovalecid'],
    data () {
        return {
            sifrantTree:{},
            dataLoading:false,
            
            dataSezona:this.sezona,
          
            updatedData: [],
            editID: null,
          
         
            sort: [
                //{ field: 'vrstakulture', dir: 'asc' }
            ],
            columns: [

               { field: "zaporednastevilka", title:"Zaporedna št. kontrole",width: "100px",filterable:false,footerCell:this.nogaNazivVsot,type:"number",editor:"numeric"},
                { field: "datumkontrole", filterable:false, title:"Datum kontrole",width: "170px", type:"date",editor:"date",format:"{0:d}"},
                { field: "trajanje", title:"Trajanje (h)",width: "100px",filterable:false,type:"number",editor:"numeric",format:"{0:n2}"},
                { field: "vrstakontrole", title:"Vrsta kontrole",cell:'vrstakontrole',width: "220px"},
                { field: "vzorci", title:"Vzorci",width: "100px"},
                { field: "posebnosti", title:"Posebnosti",width: "100px"},
                { field: "priloge", title:"Priloge",width: "100px"},
                { field: "mnenjekontrolorja", cell:"mnenjekontrolorja", title:"Mnenje kontrolorja",width: "220px"},
                { field: "sifrakontrolorja", title:"Kontrolor",width: "100px"},
              /*   { field: "kolicina", title:"Količina",width: "100px",filterable:false,type: "number",footerCell: this.nogaVsotaKolicina,width: "150px",format: '{0:n2}'},
                { field: "merskaenotanaziv", title:"Enota",width: "100px",filterable:false},
                //{ field: "enota", title:"Enota", type:"string",filterable:false,width: "80px"},
                { field: "veljavnostcertifikataod", filterable:false, title:"Datum določitve statusa",width: "170px", cell:this.formatDate},
                //template: "#= kendo.toString(kendo.parseDate(veljavnostcertifikataod, 'yyyy-MM-dd'), 'MM/dd/yyyy') #"},
                //filter:'date',format: "{0:d}"},
               // { field: "veljavnostcertifikatado", title:"Veljavnost statusa", type:"string",editor: 'date',width: "150px",format: '{0:d}'},

                { field: "statuspridelkanaziv", title:"Status",width: "150px"},
                */
                { cell: 'ukaznigumbi', width: '210px', hidden:this.editDisabled },
            ],
          

           

        }
    },
      computed: {
        editDisabled(){
          return (this.predelovalec.pisanje==0)
        },

        ...mapState({gridData(state) {
          return state.kontrolaPredelava.kontrolaPredelava;
        }}),

        ...mapState('predelava', ['predelovalec']) ,
        ...mapState('sifrant', ['sifrant']) ,
        ...mapState('users',['sezonePisanje']),

        hasItemsInEdit() {
            return this.gridData.filter(p => p.inEdit).length > 0;
        },
      
           },
    created () {

this.dataSezona={sezona:this.sezona};
this.naloziPodatke();

      
    },
  


    methods: {
      ...mapActions('predelava', ['loadIdPoSezoni','loadOne']),
        ...mapActions('kontrolaPredelava', ['load','save','loadPreteklaSezona']),
        ...mapActions({naloziSifrant: 'sifrant/load'}),
        ...mapMutations('kontrolaPredelava',['update',"add","remove","makeEditable",'replace']),
        rowRenderFunction: function (h, trElement , defaultSlots, props ) {
            console.log(trElement);
            console.log(props.dataItem);
            if(props.dataItem.jeaktivna!=1)
            trElement.data.class+=" deleted_element";

                return trElement;
            },
             nogaNazivVsot: function (h, emptyElement , props, listeners ) {
            return h('span', {}, ['Vsota:']);
        },
        //gvž in število
        nogaVsotaStevila: function (h, emptyElement , props, listeners ) {
          if(this.gridData)
            return h('span', {}, [kendo.toString(this.gridData.reduce((acc, current) => acc+=current.jeaktivna?(current.stevilo?current.stevilo:0):0, 0),"n0")]);
        },
        nogaVsotaGvz: function (h, emptyElement , props, listeners ) {
          if(this.gridData)
            return h('span', {}, [kendo.toString(this.gridData.reduce((acc, current) => acc+=current.jeaktivna?(current.vsotagvz?current.vsotagvz:0):0, 0),"n3")]);
        },
              formatDate: function (h, emptyElement , props, listeners ) {
            if(props.dataItem.inEdit)
              return emptyElement
            else
             return h('td', {attrs:{colspan:1}}, [kendo.toString(kendo.parseDate(props.dataItem[props.field]),'d')]);
        },
            //error handle za prazen šifrnat!!!!
        naloziPodatke: function(){
          this.dataLoading=true;

        this.replace([]);
        this.loadOne({sezona:this.dataSezona.sezona,predelovalecid:this.predelovalecid}).then(()=>{

        this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"vrstakontrolepredelovalca"}).then(()=>{
           this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"mnenjekontrolorja"}).then(()=>{
         this.load({sezona:this.dataSezona.sezona,predelovalecid:this.predelovalecid,makeEditable:!this.editDisabled}).then(

          data=>{this.dataLoading=false;},


          error=>{console.log("tukaj sem!!!");this.dataLoading=false;});
        
       });
            });

        });
       
      
        },
        sifranKontrolaChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


            if(!dataItem.oldValues["vrstakontroleid"])
              dataItem.oldValues["vrstakontroleid"] =dataItem["vrstakontroleid"];

            if(!dataItem.oldValues["vrstakontrole"])
              dataItem.oldValues["vrstakontrole"] =dataItem["vrstakontrole"];



            Vue.set( dataItem, 'vrstakontrole',e.value.naziv);
              Vue.set( dataItem, 'vrstakontroleid',e.value.id);
            
    
        },
          sifranMnenjeChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


            if(!dataItem.oldValues["mnenjekontrolorjaid"])
              dataItem.oldValues["mnenjekontrolorjaid"] =dataItem["mnenjekontrolorjaid"];

            if(!dataItem.oldValues["mnenjekontrolorja"])
              dataItem.oldValues["mnenjekontrolorja"] =dataItem["mnenjekontrolorja"];

            Vue.set( dataItem, 'mnenjekontrolorja',e.value.naziv);
              Vue.set( dataItem, 'mnenjekontrolorjaid',e.value.id);
            
    
        },
        itemChange: function (e) {
            if(!e.dataItem.oldValues)
              e.dataItem.oldValues={}
            if(!e.dataItem.oldValues[e.field])
              e.dataItem.oldValues[e.field] =e.dataItem[e.field];
          
          Vue.set( e.dataItem, e.field,e.value);

        //  if(e.field=="stevilo")
          //    Vue.set( e.dataItem, 'vsotagvz',(e.value?e.value:0)*this.sifrant['proizvod'].find(s=>s.id==e.dataItem.proizvodid).gvz);              
           
        },
        dodajIzPrejsnjeSezone(){
            this.loadPreteklaSezona({sezona:this.dataSezona.sezona,predelovalecid:this.predelovalecid,makeEditable:!this.editDisabled});

        },

        //default vrednosti
         vstavi() {
            const dataItem = { inEdit: true,jeaktivna:1,
                  zaporednastevilka:this.gridData.reduce((a,c)=>{return c.zaporednastevilka>a?c.zaporednastevilka:a},0)+1,
                  datumkontrole:new Date(),
                  vrstakontroleid:this.sifrant["vrstakontrolepredelovalca"][0].id,
                  vrstakontrole:this.sifrant["vrstakontrolepredelovalca"][0].naziv,
                  mnenjekontrolorjaid:this.sifrant["mnenjekontrolorja"][0].id,
                  mnenjekontrolorja:this.sifrant["mnenjekontrolorja"][0].naziv
                   };
            this.add(dataItem);
        },
        edit: function (e) {
            e.dataItem.inEdit = true;
            e.dataItem.jeaktivna = 1;
            
            this.update(e.dataItem);
        },
        cancel(e) {
            if (e.dataItem.id>0) {
            var dataItem=e.dataItem;
            for (const value in dataItem.oldValues){
               Vue.set( dataItem, value,dataItem.oldValues[value]);
            }
             Vue.set( dataItem, jeaktivna,0);
             Vue.set( dataItem, jeaktivna,1);
              this.update(dataItem);
            
            } else {
                this.remove(e.dataItem);
            }
        },
        saveItem: function(e) {
           e.dataItem.inEdit = undefined;
             e.dataItem.jeaktivna = 1;
            this.update(e.dataItem);
        },
        removeItem(e) {
            e.dataItem.inEdit =!e.dataItem.inEdit;
            e.dataItem.jeaktivna=e.dataItem.jeaktivna?0:1;
            this.update(e.dataItem);

        },
       sezonaChange(event) {
            const sezona = event.value;
            this.dataSezona=sezona;
            this.loadIdPoSezoni({sezona:sezona.sezona,subjid:this.predelovalec.subjid}).then(predelovalec=>{
              this.predelovalecid=predelovalec.id;
             this.$router.push({ name: 'kontrolaPredelava', params: {sezona:sezona.sezona,predelovalecid:predelovalec.id} });
             this.naloziPodatke();
              });



        },
/*
             @datastatechange="dataStateChange"
dataStateChange (event) {
            console.log("DataStateChange");
            console.log(event);
            this.createAppState(event.data);
            this.dataResult = process(this.gerk, {});

        },
  */    
        shraniKontrole () {
              this.save();
    },
       
        
    }
};
</script>

